import { DEMO_IDS, DEMO_IMEI, DEMO_MQTT_USER } from './mqttPacket'
import { buildSupervisorioReporte as buildReporteFromReadings, buildSupervisorioHistorico as buildHistoricoFromReadings,} from './sandboxReadings'

const buildWidget = ({
    id,
    type,
    descricao,
    campo,
    parametros = {},
}) => ({
    id,
    type: String(type),
    descricao: encodeURI(descricao),
    equipamento: DEMO_IMEI,
    mqtt: DEMO_MQTT_USER,
    campo,
    parametros: {
        minutos_alerta_semcomunicacao: 30,
        ...parametros,
    },
})

export const buildDemoSupervisorio = () => {
    const widgets = [
        buildWidget({
            id: 'demo-gauge-energia',
            type: 14,
            descricao: 'Energia consumida',
            campo: 'energia',
            parametros: {
                tipo_gauge: 'absoluto',
                valor_maximo: 80,
                valor_normal: { min: 0, max: 50 },
                valor_alerta: { min: 50, max: 65 },
                valor_perigo: { min: 65, max: 80 },
            },
        }),
        buildWidget({
            id: 'demo-reservatorio-v2',
            type: 12,
            descricao: 'Reservatório',
            campo: 'nivel',
            parametros: {
                valor_altura: 5,
                valor_normal: { min: 45, max: 100 },
                valor_alerta: { min: 25, max: 45 },
                valor_perigo: { min: 0, max: 25 },
            },
        }),
        buildWidget({
            id: 'demo-valor-atual-temperatura',
            type: 2,
            descricao: 'Temperatura',
            campo: 'temperatura',
            parametros: {
                valor_normal: 30,
                valor_alerta: 35,
                valor_perigo: 40,
            },
        }),
        buildWidget({
            id: 'demo-valor-atual-vazao',
            type: 2,
            descricao: 'Vazão do poço',
            campo: 'vazao',
            parametros: {
                valor_normal: 10,
                valor_alerta: 12,
                valor_perigo: 14,
            },
        }),
        buildWidget({
            id: 'demo-valor-atual-volume',
            type: 2,
            descricao: 'Volume do hidrômetro',
            campo: 'volume_hidrometro',
            parametros: {
                valor_normal: 20,
                valor_alerta: 25,
                valor_perigo: 30,
            },
        }),
        buildWidget({
            id: 'demo-valor-atual-horas',
            type: 2,
            descricao: 'Horas de funcionamento',
            campo: 'horas',
            parametros: {
                valor_normal: 3,
                valor_alerta: 5,
                valor_perigo: 8,
            },
        }),
        buildWidget({
            id: 'demo-poco-nivel',
            type: 5,
            descricao: 'Nível do poço',
            campo: 'nivel',
            parametros: {
                instalacao_bomba: 30,
                instalacao_sensor: 28,
                nivel_estatico: 8,
                campo_vazao: 'vazao',
            },
        }),
        buildWidget({
            id: 'demo-linha-nivel',
            type: 6,
            descricao: 'Histórico de nível',
            campo: 'nivel',
            parametros: {
                periodo: '24',
                valores_anteriores: true,
                valor_minimo: 0,
                valor_maximo: 6,
            },
        }),
        buildWidget({
            id: 'demo-barra-volume',
            type: 7,
            descricao: 'Volume por hora',
            campo: 'volume_hidrometro',
            parametros: {
                periodo: '24',
                valores_anteriores: true,
            },
        }),
    ]

    const layoutItems = [
        { i: 'demo-reservatorio-v2', x: 0, y: 0, w: 3, h: 10, minW: 2, minH: 6, maxW: 8, maxH: 22 },
        { i: 'demo-gauge-energia', x: 3, y: 0, w: 3, h: 10, minW: 3, minH: 8 },
        { i: 'demo-valor-atual-temperatura', x: 6, y: 0, w: 3, h: 5, minW: 3, minH: 4 },
        { i: 'demo-valor-atual-vazao', x: 6, y: 5, w: 3, h: 5, minW: 3, minH: 4 },
        { i: 'demo-valor-atual-volume', x: 9, y: 0, w: 3, h: 5, minW: 3, minH: 4 },
        { i: 'demo-valor-atual-horas', x: 9, y: 5, w: 3, h: 5, minW: 3, minH: 4 },
        { i: 'demo-poco-nivel', x: 0, y: 10, w: 3, h: 12, minW: 2, minH: 12 },
        { i: 'demo-linha-nivel', x: 3, y: 10, w: 5, h: 12, minW: 4, minH: 6 },
        { i: 'demo-barra-volume', x: 8, y: 10, w: 4, h: 12, minW: 4, minH: 6 },
    ]

    return {
        id: DEMO_IDS.supervisorio,
        descricao: 'Supervisório Demonstração',
        hash: 'demo-supervisorio',
        widgets: JSON.stringify(widgets),
        layout: JSON.stringify({
            lg: layoutItems,
            md: layoutItems,
            sm: layoutItems,
            xs: layoutItems,
            xxs: layoutItems,
        }),
    }
}

export const buildSupervisorioReporte = (identificacoes) =>
    buildReporteFromReadings(identificacoes)

export const buildSupervisorioHistorico = (requestBody) =>
    buildHistoricoFromReadings(requestBody)
